module.exports = __webpack_public_path__ + "static/media/reach-and-squat.a9806624.mp4";